import {all, takeEvery, takeLatest} from "redux-saga/effects";

import { settingsActionsConstants } from "@/store/actions";
import {
  _sharedWorkerFetchGeoIpData,
  _sharedWorkerUpdateSettingsMethod
} from "@/shared/store/settings/saga";

export default function* settingsSaga() {
  yield all([
    takeEvery(settingsActionsConstants.UPDATE_SETTINGS, _sharedWorkerUpdateSettingsMethod),
    takeLatest(settingsActionsConstants.FETCH_GEO_IP_DATA, _sharedWorkerFetchGeoIpData),
  ]);
}
